<template>
  <div class="mt-lg-5 py-lg-5">
    <div class="breadcrumb pt-5 pb-4">
      <div class="container">
        <a class="d-inline-block text-dark">Support</a>

        <span class="caret">></span>
        <p class="d-inline-block font-weight-bold">Glossary</p>
      </div>
    </div>
    <div class="container mt-5 text-center">
      <h2>{{ data.heading }}</h2>
      <p>
        {{ data.description }}
      </p>
    </div>

    <ul
      v-scroll-spy-active
      v-scroll-spy-link
      class="nav-tag bg-light py-3 w-100 text-center mt-5"
    >
      <li
        v-for="item in items"
        class="glossory-index d-inline-block py-1 py-md-2 px-md-3 px-lg-3 px-2"
      >
        <a>{{ item.index }}</a>
      </li>
    </ul>
    <div class="container text-center">
      <div v-scroll-spy="{ offset: 90 }" class="mt-5">
        <div v-for="itemData in items" class="index my-5">
          <div class="mb-3">
            <div v-for="(item, index) in itemData.items" class="mb-4">
              <h3 class="mb-2">{{ item.name }}</h3>
              <p v-html="item.description"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: "glossary", // global_search_results
  props: ["data"],
  data() {
    return {
      items: this.data.content,
    };
  },

  created() {
    this.setShowLinks(true)
    bus.$emit("navigation:reversed", true);
  },

  methods: {
    ...mapMutations(['setShowLinks'])
  }
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.nav-tag {
  position: sticky;
  top: 0;
  list-style: none;
  display: flex;
  justify-content: center;
  display: inline-block;
  @media (max-width: 768px) {
    top: 5.25rem;
  }
  @media (max-width: 568px) {
    top: 3rem;
  }
  .glossory-index {
    font-size: 1.125rem;
    font-weight: bold;
    cursor: pointer;
    @media (max-width: 567px) {
      font-size: 0.725rem;
    }
    a {
      color: #232323;
    }
    &.active {
      border: 2px solid #1788c3;
      border-radius: 50%;

      a {
        color: #1788c3;
      }
    }
  }
}
.index {
  border-bottom: 1px solid #ddd;
}
.breadcrumb {
  background-color: rgba(226, 234, 240, 0.75);
  cursor: pointer;
}
</style>
